import React from 'react';
import { Button } from './Button';
export const HowItWorksSection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/6oqdjPAT?coupon_code=7DAYRESETSPECIAL2025';
  return <section className="bg-gradient-to-b from-teal-800 to-teal-900 text-white py-16" data-id="element-225">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-226">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-227">
          How It Works
        </h2>
        <div className="grid md:grid-cols-2 gap-8 mb-10" data-id="element-228">
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-229">
            <h3 className="text-xl font-bold mb-3" data-id="element-230">7-Day Guided Reset</h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-231">
              <li data-id="element-232">Follow at your own pace</li>
              <li data-id="element-233">Every day includes a 10–20 minute guided practice</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-234">
            <h3 className="text-xl font-bold mb-3" data-id="element-235">
              Lifetime Access to All Content
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-236">
              <li data-id="element-237">Revisit your favorite tools any time</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-238">
            <h3 className="text-xl font-bold mb-3" data-id="element-239">
              Evidence-Based, Therapist-Led
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-240">
              <li data-id="element-241">Created by a Doctor of Behavioral Health & Somatic Expert</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-242">
            <h3 className="text-xl font-bold mb-3" data-id="element-243">
              Bonus: Deep-Dive Video Lessons
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-244">
              <li data-id="element-245">Learn how trauma wires the body and how to rewire it</li>
            </ul>
          </div>
        </div>
        <p className="text-center text-lg mb-6" data-id="element-246">
          Already Know The Science? Now You'll Feel the Shift — With Just One
          Week of Daily Body-Based Practice.
        </p>
        <div className="flex justify-center" data-id="element-247">
          <Button link={checkoutUrl} data-id="element-248">Try the 7-Day Reset – Just $9 ➔</Button>
        </div>
      </div>
    </section>;
};